/**
 * Created by Alex Aguilar on 6/24/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('adminFlightsCtrl', adminFlightsCtrl);

    adminFlightsCtrl.$inject = ['$timeout', '$stateParams', 'linkService', 'tabAdminFlights', 'modelAircrafts',
        'modelAircraftFlights', 'aircraftFlights', 'flights', 'modelAircraftService', 'dateService', 'datePickerService',
        'specialInvoiceReportService'];

    function adminFlightsCtrl($timeout, $stateParams, linkService, tabAdminFlights, modelAircrafts, modelAircraftFlights,
                              aircraftFlights, flights, modelAircraftService, dateService, datePickerService,
                              specialInvoiceReportService){

        var vm = this;
        vm.modelAircrafts = (modelAircrafts !== undefined && modelAircrafts.data._embedded) ? modelAircrafts.data._embedded.makers : [];
        vm.aircrafts = (modelAircrafts !== undefined && modelAircrafts.data._embedded) ? modelAircrafts.data._embedded.aircrafts : [];
        vm.scheduleActive = false;
        vm.tabs = tabAdminFlights;
        vm.linkService = linkService;
        vm.flights = {};
        vm.grid = {
            'date': ($stateParams.date != "") ? new Date(parseInt($stateParams.date)) : new Date()
        };

        vm.flightFilter = {
            'date': ($stateParams.date != "") ? new Date(parseInt($stateParams.date)) : new Date(),
            'modelAircraft': null,
            'type': ($stateParams.type != "") ? $stateParams.type : "grid",
            'model': ($stateParams.model != "") ? $stateParams.model : "all"
        }

        vm.dateParam = $stateParams.date;

        vm.modelAircraftFlights = [];
        vm.radioFlight = 'grid';
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.beforeYesterday = new Date();
        vm.beforeYesterday = dateService.addDays(vm.beforeYesterday, -60);
        vm.beforeYesterday.setHours(0,0,0);

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.beforeYesterday
            },
            closed: function(args) {
                if(args.closeDate != ""){
                    vm.changeGridDay();
                }
            }
        };


        if(vm.flightFilter.type == 'grid'){
            vm.timeSteps = [];
            vm.arraySchedule = [];

            if(modelAircraftFlights != null){
                var arrayModelAircrafts = generateArrayScheduleModelAircraft(modelAircraftFlights, dateService, linkService, vm);
                var arrayAircrafts = generateArrayScheduleAircraft(aircraftFlights, dateService, linkService, vm);
                vm.arraySchedule = arrayModelAircrafts.concat(arrayAircrafts);
                vm.scheduleStart = (vm.timeSteps.length > 0) ? resetTimeStep(vm.timeSteps[0]) : "00:00";
                vm.scheduleEnd = (vm.timeSteps.length > 0) ? resetTimeStep(vm.timeSteps[vm.timeSteps.length - 1]) : "00:00";
            }
        }else if(vm.flightFilter.type == 'list'){
            vm.flights = flights;
        }

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.getModelAircraftFlights = function(dateHex){
            modelAircraftService.getModelAircraftFlights(dateHex)
                .then(function(res){
                    vm.modelAircraftFlights = res;
                })
        }

        vm.changeGridDay = function(){
            $timeout(function(){
                /*var date = vm.grid.date;
                if(date != undefined){
                    var dateTime = date.getTime(),
                        model = (vm.grid.modelAircraft != undefined) ? linkService.getLinkId(vm.grid.modelAircraft._links.self.href) : "all";
                    linkService.reloadRoute(linkService.getCurrentRouteName(), {date: dateTime, model: model})
                }*/
                var date = vm.flightFilter.date;
                if(date != undefined){
                    var dateTime = date.getTime(),
                        model = (vm.flightFilter.modelAircraft != undefined) ? linkService.getLinkId(vm.flightFilter.modelAircraft._links.self.href) : "all";
                    linkService.reloadRoute(linkService.getCurrentRouteName(), {date: dateTime, model: model, type: vm.flightFilter.type})
                }
            }, 100);
        }

        vm.changeAdminFlightType = function(type){
            var date = vm.flightFilter.date;
            var dateTime = date.getTime(),
                model = (vm.flightFilter.modelAircraft != undefined) ? linkService.getLinkId(vm.flightFilter.modelAircraft._links.self.href) : "all";
            linkService.reloadRoute(linkService.getCurrentRouteName(), {date: dateTime, model: model, type: type})
        }

        vm.updateReserves = function () {
            specialInvoiceReportService.getUpdateReserves();
        }

        function getModelAircraftFlights(dateTime, cb){
            modelAircraftService.getModelAircraftFlights(dateTime)
                .then(function(response) {
                    var data = [];
                    if(response.data._embedded){
                        data = generateArraySchedule(response.data._embedded.modelAircrafts);
                        cb(data);
                    }
                });
        }
    }

    function generateArrayScheduleModelAircraft(modelAircrafts, dateService, linkService, vm){
        var arraySchedule = [],
            arrayScheduleNames = [];

        angular.forEach(modelAircrafts, function(modelAircraft, key){
            var posName = arrayScheduleNames.indexOf(modelAircraft.name),
                scheduleName = modelAircraft.name;
            if(posName !== -1){
                scheduleName = "";
            }
            arrayScheduleNames.push(modelAircraft.name);
            arraySchedule.push({'name': scheduleName, 'appointments': []});
            angular.forEach(modelAircraft._embedded.flights, function(flight){
                var isActive = thereIsActive(flight._embedded.departureflights);
                angular.forEach(flight._embedded.departureflights, function(departureFlight){
                    var dateStart = dateService.getDateByDateZone(departureFlight.departureDate), // new Date(parseInt(departureFlight.departureDate)),
                        dateEnd = dateService.getDateByDateZone(departureFlight.arrivalDate), // new Date(parseInt(departureFlight.arrivalDate)),
                        departureDateTime = dateService.convertTimeToZero(dateStart.getHours(), dateStart.getMinutes()),
                        arrivalDateTime = dateService.convertTimeToZero(dateEnd.getHours(), dateEnd.getMinutes()),
                        segmentRoute = departureFlight._embedded.segment.name;

                    segmentRoute = segmentRoute.replace(/[ ]/g, "");
                    segmentRoute = segmentRoute.split('-');

                    arraySchedule[key].appointments.push({
                        'start': departureDateTime,
                        'end': arrivalDateTime,
                        'title': flight.flightNumber,
                        'class': 'nonsense1',
                        'flightId': linkService.getLinkId(flight._links.self.href),
                        'flightNumber': flight.flightNumber,
                        'route': segmentRoute[0] + '-' + segmentRoute[1],
                        'startRoute': segmentRoute[0],
                        'endRoute': segmentRoute[1],
                        'payload': {},
                        'isActive': isActive
                    });

                    var posStart = vm.timeSteps.indexOf(departureDateTime),
                        posEnd = vm.timeSteps.indexOf(arrivalDateTime);

                    if(posStart == -1){
                        vm.timeSteps.push(departureDateTime);
                    }
                    if(posEnd == -1){
                        vm.timeSteps.push(arrivalDateTime);
                    }
                });
            });
        });

        vm.timeSteps = orderTimeSteps(vm.timeSteps);

        var newAppointments = [];
        angular.forEach(arraySchedule, function(schedule, indexSchedule){
            newAppointments.push({
                "name": schedule.name,
                "appointments0": [],
                "appointments1":[],
                "appointments2":[],
                "appointments3":[],
                "appointments4":[],
                "appointments5":[]
            });

            angular.forEach(schedule.appointments, function(appointment, index){
                if(index == 0){
                    newAppointments[indexSchedule].appointments0.push(appointment);
                }else{
                    var exits = checkObjectRange(newAppointments[indexSchedule].appointments0, appointment);
                    if(!exits){
                        var resultNumberFlight = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments0", 6);
                        if(resultNumberFlight.appointment.length > 0){
                            newAppointments[indexSchedule][resultNumberFlight.nameAppointment].push(appointment);
                        }else{
                            newAppointments[indexSchedule].appointments0.push(appointment);
                        }
                    }else{
                        var exitsTwo = checkObjectRange(newAppointments[indexSchedule].appointments1, appointment);
                        if(!exitsTwo){
                            var resultNumberFlight2 = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments1", 6);
                            if(resultNumberFlight2.appointment.length > 0){
                                newAppointments[indexSchedule][resultNumberFlight2.nameAppointment].push(appointment);
                            }else{
                                newAppointments[indexSchedule].appointments1.push(appointment);
                            }
                        }else{
                            var exitsThree = checkObjectRange(newAppointments[indexSchedule].appointments2, appointment);
                            if(!exitsThree){
                                var resultNumberFlight3 = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments2", 6);
                                if(resultNumberFlight3.appointment.length > 0){
                                    newAppointments[indexSchedule][resultNumberFlight3.nameAppointment].push(appointment);
                                }else{
                                    newAppointments[indexSchedule].appointments2.push(appointment);
                                }
                            }else{
                                var exitsFour = checkObjectRange(newAppointments[indexSchedule].appointments3, appointment);
                                if(exitsFour){
                                    var resultNumberFlight4 = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments3", 6);
                                    if(resultNumberFlight4.appointment.length > 0){
                                        newAppointments[indexSchedule][resultNumberFlight4.nameAppointment].push(appointment);
                                    }else{
                                        newAppointments[indexSchedule].appointments3.push(appointment);
                                    }
                                }else{
                                    var exitsFive = checkObjectRange(newAppointments[indexSchedule].appointments4, appointment);
                                    if(exitsFive){
                                        var resultNumberFlight5 = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments4", 6);
                                        if(resultNumberFlight5.appointment.length > 0){
                                            newAppointments[indexSchedule][resultNumberFlight5.nameAppointment].push(appointment);
                                        }else{
                                            newAppointments[indexSchedule].appointments4.push(appointment);
                                        }
                                    }else{
                                        newAppointments[indexSchedule].appointments5.push(appointment);
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });

        var result = [];
        angular.forEach(newAppointments, function(newAppointment) {
            fillFlights(newAppointment, result, 6);
        });

        return result;
    }

    function fillFlights(appointment, arrayResult, lengthAppointment){
        for(var i = 0; i < lengthAppointment; i++){
            var keyAppointment = "appointments" + i,
                postAppointment = appointment[keyAppointment],
                name = (i == 0) ? appointment.name : "";

            if (postAppointment.length > 0) {
                arrayResult.push({
                    "name": name,
                    "appointments": postAppointment
                });
            }
        }
    }

    function checkFlightNumber(appointment, appointments, nameAppointment, lengthAppointment){
        var result = {
            'exits': false,
            'appointment': [],
            'nameAppointment': ""
        }
        for(var i = 0; i < lengthAppointment; i++){
            var keyAppointment = "appointments" + i,
                currentAppointment = appointments[keyAppointment];
            if(keyAppointment != nameAppointment){
                if (currentAppointment.length > 0) {
                    for(var j = 0; j < currentAppointment.length; j++){
                        if(appointment.flightNumber == currentAppointment[j].flightNumber){
                            result.nameAppointment = keyAppointment;
                            result.appointment = currentAppointment;
                        }
                    }
                }
            }
        }
        return result;
    }

    function generateArrayScheduleAircraft(aircraftFlights, dateService, linkService, vm){
        var arraySchedule = [],
            arrayScheduleNames = [];

        angular.forEach(aircraftFlights, function(aircraftFlight, key){
            var posName = arrayScheduleNames.indexOf(aircraftFlight.plaque),
                scheduleName = aircraftFlight._embedded.modelAircraft.name + " / " + aircraftFlight.plaque;

            if(posName !== -1){
                scheduleName = "";
            }
            arrayScheduleNames.push(aircraftFlight.plaque);
            arraySchedule.push({'name': scheduleName, 'appointments': []});

            angular.forEach(aircraftFlight._embedded.flights, function(flight){
                var isActive = thereIsActive(flight._embedded.departureflights);
                angular.forEach(flight._embedded.departureflights, function(departureFlight){
                    var dateStart = dateService.getDateByDateZone(departureFlight.departureDate), // new Date(parseInt(departureFlight.departureDate)),
                        dateEnd = dateService.getDateByDateZone(departureFlight.arrivalDate), // new Date(parseInt(departureFlight.arrivalDate)),
                        departureDateTime = dateService.convertTimeToZero(dateStart.getHours(), dateStart.getMinutes()),
                        arrivalDateTime = dateService.convertTimeToZero(dateEnd.getHours(), dateEnd.getMinutes()),
                        segmentRoute = departureFlight._embedded.segment.name;

                    segmentRoute = segmentRoute.replace(/[ ]/g, "");
                    segmentRoute = segmentRoute.split('-');

                    arraySchedule[key].appointments.push({
                        'start': departureDateTime,
                        'end': arrivalDateTime,
                        'title': flight.flightNumber,
                        'class': 'nonsense1',
                        'flightId': linkService.getLinkId(flight._links.self.href),
                        'flightNumber': flight.flightNumber,
                        'route': segmentRoute[0] + '-' + segmentRoute[1],
                        'startRoute': segmentRoute[0],
                        'endRoute': segmentRoute[1],
                        'payload': {},
                        'isActive': isActive
                    });

                    var posStart = vm.timeSteps.indexOf(departureDateTime),
                        posEnd = vm.timeSteps.indexOf(arrivalDateTime);

                    if(posStart == -1){
                        vm.timeSteps.push(departureDateTime);
                    }
                    if(posEnd == -1){
                        vm.timeSteps.push(arrivalDateTime);
                    }
                });
            });
        });

        vm.timeSteps = orderTimeSteps(vm.timeSteps);

        var newAppointments = [];
        angular.forEach(arraySchedule, function(schedule, indexSchedule){
            newAppointments.push({
                "name": schedule.name,
                "appointments0": [],
                "appointments1":[],
                "appointments2":[],
                "appointments3":[],
                "appointments4":[],
                "appointments5":[]
            });

            angular.forEach(schedule.appointments, function(appointment, index){
                if(index == 0){
                    newAppointments[indexSchedule].appointments0.push(appointment);
                }else{
                    var exits = checkObjectRange(newAppointments[indexSchedule].appointments0, appointment);
                    if(!exits){
                        var resultNumberFlight = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments0", 6);
                        if(resultNumberFlight.appointment.length > 0){
                            newAppointments[indexSchedule][resultNumberFlight.nameAppointment].push(appointment);
                        }else{
                            newAppointments[indexSchedule].appointments0.push(appointment);
                        }
                    }else{
                        var exitsTwo = checkObjectRange(newAppointments[indexSchedule].appointments1, appointment);
                        if(!exitsTwo){
                            var resultNumberFlight2 = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments1", 6);
                            if(resultNumberFlight2.appointment.length > 0){
                                newAppointments[indexSchedule][resultNumberFlight2.nameAppointment].push(appointment);
                            }else{
                                newAppointments[indexSchedule].appointments1.push(appointment);
                            }
                        }else{
                            var exitsThree = checkObjectRange(newAppointments[indexSchedule].appointments2, appointment);
                            if(!exitsThree){
                                var resultNumberFlight3 = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments2", 6);
                                if(resultNumberFlight3.appointment.length > 0){
                                    newAppointments[indexSchedule][resultNumberFlight3.nameAppointment].push(appointment);
                                }else{
                                    newAppointments[indexSchedule].appointments2.push(appointment);
                                }
                            }else{
                                var exitsFour = checkObjectRange(newAppointments[indexSchedule].appointments3, appointment);
                                if(exitsFour){
                                    var resultNumberFlight4 = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments3", 6);
                                    if(resultNumberFlight4.appointment.length > 0){
                                        newAppointments[indexSchedule][resultNumberFlight4.nameAppointment].push(appointment);
                                    }else{
                                        newAppointments[indexSchedule].appointments3.push(appointment);
                                    }
                                }else{
                                    var exitsFive = checkObjectRange(newAppointments[indexSchedule].appointments4, appointment);
                                    if(exitsFive){
                                        var resultNumberFlight5 = checkFlightNumber(appointment, newAppointments[indexSchedule], "appointments4", 6);
                                        if(resultNumberFlight5.appointment.length > 0){
                                            newAppointments[indexSchedule][resultNumberFlight5.nameAppointment].push(appointment);
                                        }else{
                                            newAppointments[indexSchedule].appointments4.push(appointment);
                                        }
                                    }else{
                                        newAppointments[indexSchedule].appointments5.push(appointment);
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });

        var result = [];
        angular.forEach(newAppointments, function(newAppointment) {
            fillFlights(newAppointment, result, 6);
        });

        return result;

        //return arraySchedule;
    }

    function generateArraySchedule(modelAircrafts){
        var arraySchedule = [],
            arrayScheduleNames = [];

        angular.forEach(modelAircrafts, function(modelAircraft, key){
            var posName = arrayScheduleNames.indexOf(modelAircraft.name),
                scheduleName = modelAircraft.name;
            if(posName !== -1){
                scheduleName = "";
            }
            arrayScheduleNames.push(modelAircraft.name);
            arraySchedule.push({'name': scheduleName, 'appointments': []});
            angular.forEach(modelAircraft._embedded.flights, function(flight){
                angular.forEach(flight._embedded.departureflights, function(departureFlight){
                    var dateStart = new Date(parseInt(departureFlight.departureDate)),
                        dateEnd = new Date(parseInt(departureFlight.arrivalDate)),
                        departureDateTime = convertTime(dateStart.getHours(), dateStart.getMinutes()),
                        arrivalDateTime = convertTime(dateEnd.getHours(), dateEnd.getMinutes());

                    arraySchedule[key].appointments.push({
                        'start': departureDateTime,
                        'end': arrivalDateTime,
                        'title': flight.flightNumber,
                        'class': 'nonsense',
                        'payload': {}
                    });
                });
            });
        });
        return arraySchedule;
    }

    function checkObjectRange(appointments, objectAppointment){
        var res = false,
            startObject = convertTimeToInteger(objectAppointment.start),
            endObject = convertTimeToInteger(objectAppointment.end);

        for(var i = 0; i < appointments.length; i++){
            var start = convertTimeToInteger(appointments[i].start);
            var end = convertTimeToInteger(appointments[i].end);
            if(startObject >= start && startObject <= end){
                res = true;
                break;
            }else if(endObject >= start && endObject <= end){
                res = true;
                break;
            }
        }
        return res;
    }

    function convertTimeToInteger(time){
        var splitTime = time.split(":"),
            res = splitTime[0] + splitTime[1];
        return parseInt(res);
    }

    function convertTime(timeHour, timeMinute){
        if(timeHour < 10){
            timeHour = "0" + timeHour;
        }
        if(timeMinute < 10){
            timeMinute = "0" + timeMinute;
        }
        return timeHour + ":" + timeMinute;
    }

    function orderTimeSteps(timeSteps){
        var aux;
        for(var i = 0; i < timeSteps.length; i++){
            for(var j = 0; j < timeSteps.length; j++){
                var timeI = convertTimeToInteger(timeSteps[i]);
                var timeJ = convertTimeToInteger(timeSteps[j]);
                if(timeJ > timeI) {
                    aux = timeSteps[j];
                    timeSteps[j]= timeSteps[i];
                    timeSteps[i]= aux;
                }
            }
        }
        return timeSteps;
    }

    function resetTimeStep(time){
        var timeSplit = time.split(":");
        return parseInt(timeSplit[0]);
    }

    function thereIsActive(departureFlights){
        var res = true;
        for(var i=0; i<departureFlights.length; i++){
            var segmentFlights = departureFlights[i]._embedded.segmentflights;
            for(var j=0; j<segmentFlights.length; j++){
                if(segmentFlights[j].state!=='A'){
                    res = false;
                    break;
                }
            }
            if(!res) break;
        }
        return res;
    }

})();
